import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/base-pages/about/index.tsx");
